module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"btn_login":"Login","btn_join":"Sign Up"},"ja":{"btn_login":"ログイン","btn_join":"入会案内"}}')
  delete Component.options._Ctor
}
